export class FeedbackMessage {
    name: string;
    email: string;
    description: string;
    segmentOrdinal: string;
    queryLink: string;
}
